import * as tslib_1 from "tslib";
import * as status from '../actions/status.actions';
var initialState = {
    current: null,
    trail: [],
    currentId: null,
    loading: false,
    loadProducts: false,
    showHeader: false
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case status.SET:
            return tslib_1.__assign({}, state, { loading: true });
        case status.APPLYSUCCESS:
            var page = action.payload && action.payload.current;
            var trail = (action.payload && action.payload.trail) || [];
            return tslib_1.__assign({}, state, { current: page, trail: trail, currentId: (page && page.id) || null, loading: false, loadProducts: action.payload.loadProducts });
        case status.SETHEADER:
            return tslib_1.__assign({}, state, { showHeader: action.payload });
        default:
            return state;
    }
}
export var getCurrentPageType = function (state) { return state.current && state.current.type; };
export var getPageTrail = function (state) { return state.trail; };
export var getCurrentId = function (state) { return state.currentId; };
export var getCurrentPageParams = function (state) { return state && state.current && state.current.parameters; };
export var isStatusLoading = function (state) { return state.loading; };
export var loadProducts = function (state) { return state.loadProducts; };
export var showHeader = function (state) { return state.showHeader; };
